import {createAction} from 'redux-actions';
import {apiGet, apiPost} from '../api';

const actions = {
  form_get_data: createAction('FORM_GET_DATA'),
  form_succeeded: createAction('FORM_SUCCEEDED'),
  form_failed: createAction('FORM_FAILED'),

  vrm_search: createAction('VRM_SEARCH'),
  vrm_succeeded: createAction('VRM_SUCCEEDED'),
  vrm_failed: createAction('VRM_FAILED'),

  postcode_search: createAction('POSTCODE_SEARCH'),
  postcode_succeeded: createAction('POSTCODE_SUCCEEDED'),
  postcode_failed: createAction('POSTCODE_FAILED'),

  add: createAction('FROM_ADD_ITEM'),
  remove: createAction('FROM_REMOVE_ITEM'),
};
export default actions;

const vrmSearch = (response, name, uuid) => {
  return {
    type: actions.vrm_search.toString(),
    uuid,
    name,
    payload: response,
  };
};
const vrmSucceeded = (response, name, uuid) => {
  return {
    type: actions.vrm_succeeded.toString(),
    uuid,
    name,
    payload: response,
  };
};
const vrmFailed = (response, name, uuid) => {
  return {
    type: actions.vrm_failed.toString(),
    name,
    uuid,
    payload: response,
  };
};

const postcodeSearch = (response, name, uuid) => {
  return {
    type: actions.postcode_search.toString(),
    uuid,
    name,
    payload: response,
  };
};
const postcodeSucceeded = (response, name, uuid) => {
  return {
    type: actions.postcode_succeeded.toString(),
    uuid,
    name,
    payload: response,
  };
};
const postcodeFailed = (response, name, uuid) => {
  return {
    type: actions.postcode_failed.toString(),
    name,
    uuid,
    payload: response,
  };
};

//todo refactor
export const formGetData = (response, name, uuid) => {
  return {
    type: actions.form_get_data.toString(),
    name,
    uuid,
    payload: response,
  };
};

const formSucceeded = (response, name, uuid) => {
  return {
    type: actions.form_succeeded.toString(),
    uuid,
    name,
    payload: response,
  };

};
const formFailed = (response, name, uuid) => {
  return {
    type: actions.form_failed.toString(),
    uuid,
    name,
    payload: response,
  };
};

export const getFormData = (name, uuid) =>
    apiGet(`agent/api/lead/submit-${name.replace(/_/g, '-')}`,
        {uuid},
        (res) => formGetData(res, name, uuid),
        (res) => formSucceeded(res, name, uuid),
        (res) => formFailed(res, name, uuid));

export const submit = (name, uuid, form_values) =>
    apiPost(`agent/api/lead/submit-${name.replace(/_/g, '-')}`,
        {...form_values,uuid},
        (res) => formGetData(res, name, uuid),
        (res) => formSucceeded(res, name, uuid),
        (res) => formFailed(res, name, uuid));

export const searchVrm = (name, uuid, vrm) =>
    apiGet('api/lookup/vrm',
        vrm,
        (res) => vrmSearch(res, name, uuid),
        (res) => vrmSucceeded(res, name, uuid),
        (data) => vrmFailed(data, name, uuid));

export const searchPostcode = (name, uuid, postcode) =>
    apiGet('api/lookup/postcode',
        postcode,
        (res) => postcodeSearch(res, name, uuid),
        (res) => postcodeSucceeded(res, name, uuid),
        (res) => postcodeFailed(res, name, uuid));

export const addField = (name, field) => {
  return {
    type: actions.add.toString(),
    name,
    payload: field,
  };
};
export const removeField = (name, field) => {
  return {
    type: actions.remove.toString(),
    name,
    payload: field,
  };
};